/**
 * Wohin nach dem Login: zurück zur Seite, die den Login verlangt hat (RequireAuth legt
 * sie in ``state.from`` ab), sonst ins Dashboard. Nur Pfade innerhalb des Office —
 * nie eine fremde Adresse ("//host" wäre eine).
 */
export const zielNachLogin = (state: unknown): string => {
  const from = (state as { from?: unknown } | null)?.from;
  return typeof from === 'string' && from.startsWith('/') && !from.startsWith('//') && !from.startsWith('/\\')
    ? from
    : '/dashboard';
};
